module.exports = __webpack_public_path__ + "static/20-0159809b38c587c5f22c77c6a2d81f11.jpg";